const datePickerOptions = {
  enableTime: true,
  dateFormat: "DD/MM/YYYY HH:mm",
  placeholder: "dd/mm/yyyy hh:mm",
};

export const uiSchema = t => {
  return {
    "ui:order": ["alertConfiguration", "exclusionReason", "activeFrom", "activeTo"],
    alertConfiguration: {
      id: {
        "ui:title": t("ALERT_NAME"),
        "ui:readonly": true,
      },
    },
    exclusionReason: {
      id: {
        "ui:title": t("SPECIFY_REASON_ALERT_EXCLUSION"),
      },
    },
    activeFrom: {
      "ui:widget": "date-picker",
      "ui:title": t("DATE_EXCLUDED_FROM"),
      "ui:options": datePickerOptions,
    },

    activeTo: {
      "ui:widget": "date-picker",
      "ui:title": t("DATE_EXCLUDED_TO"),
      "ui:options": datePickerOptions,
    },
  };
};
